// "id" is a back-compatibility.
// Bad:  { id:  "en", label: "English" }
// Good: { key: "en", label: "English" }
export const getOptionKey = (option) => {
  return (typeof option === "object" && option !== null) ? (option.key ?? option.id) : option;
};

export const makeOption = (key, label, additionalProps) => ({ key, label, ...additionalProps });
